<script lang="ts">
  import { isWikidataItemUri } from '#app/lib/boolean_tests'
  import Flash, { type FlashState } from '#app/lib/components/flash.svelte'
  import Link from '#app/lib/components/link.svelte'
  import { normalizeError } from '#app/lib/error'
  import { icon } from '#app/lib/icons'
  import { getWikidataItemMergeUrl } from '#app/lib/wikimedia/wikidata'
  import type { ClickEvent } from '#app/types/declarations/svelte'
  import type { SerializedHomonym } from '#entities/components/deduplicate/deduplicate_homonyms.svelte'
  import { mergeEntities } from '#entities/lib/editor/merge_entities'
  import Spinner from '#general/components/spinner.svelte'
  import type { EntityUri } from '#server/types/entity'
  import { i18n } from '#user/lib/i18n'

  let {
    fromEntityUri,
    targetEntityUri,
    homonym = $bindable(),
  }: {
    fromEntityUri: EntityUri
    targetEntityUri: EntityUri
    homonym: SerializedHomonym
  } = $props()

  let flash: FlashState | undefined = $state()
  let merging = $state(false)

  const bothAreWikidataEntities = $derived(isWikidataItemUri(fromEntityUri) && isWikidataItemUri(targetEntityUri))

  homonym.merge = async (e?: ClickEvent) => {
    e?.stopPropagation()
    if (!(fromEntityUri && targetEntityUri)) return
    homonym.isMerging = true
    merging = true
    try {
      await mergeEntities(fromEntityUri, targetEntityUri)
      homonym.merged = true
    } catch (err) {
      flash = normalizeError(err)
    } finally {
      homonym.isMerging = false
      merging = false
    }
  }
</script>

<div class="merge-action">
  {#if flash}
    <Flash bind:state={flash} />
  {:else if bothAreWikidataEntities}
    <Link
      url={getWikidataItemMergeUrl(fromEntityUri, targetEntityUri)}
      text={i18n('Merge on Wikdiata')}
      icon="external-link"
      tinyButton={true}
      classNames="wikidata"
    />
  {:else}
    <button
      class="tiny-button merge"
      onclick={homonym.merge}
      disabled={merging}
    >
      {#if merging}
        <Spinner center={true} light={true} />
      {:else}
        {@html icon('compress')}
      {/if}
      {i18n('merge')}
    </button>
  {/if}
</div>

<style lang="scss">
  @import "general/scss/utils";
  .merge-action{
    :global(.wikidata){
      background-color: $wikidata-green;
      padding: 0.4em 0.5em;
    }
  }
  .merge{
    padding: 0.4em 0.5em;
    @include display-flex(row, center, center);
  }
</style>
